import './App.css'
import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import { ToastContainer } from 'react-toastify'

import 'i18n'
import { ActivateAccount } from 'screens/ActivateAccount'
import { ConfirmEmailUpdate } from 'screens/ConfirmEmailUpdate'
import { EditCreditCard } from 'screens/EditCreditCard'
import { ResetPassword } from 'screens/ResetPassword'
import { MobileApp } from 'screens/MobileApp'
import { routes } from 'constants/routes'
import { ThemeProvider } from 'components/ThemeProvider'
import { DeleteAccount } from 'screens/DeleteAccount'
import { OpenChat } from 'screens/OpenChat'
import { OpenReferral } from 'screens/OpenReferral'
import { Support } from 'screens/Support'
import { OpenSupportCenter } from 'screens/OpenSupportCenter'
import { TellyPhone } from 'screens/TellyPhone'
import { GetApp } from 'screens/GetApp'
import { MobileRegister } from 'screens/MobileRegister'
import { PasswordResetCheckEmail } from 'screens/PasswordResetCheckEmail'

// Split out so the Amplify bundle only loads on the routes that talk to Cognito
// and the other (redirect-only) webview pages stay light.
const Register = lazy(() =>
  import('screens/Register').then((module) => ({ default: module.Register }))
)

const ResetPasswordV2 = lazy(() =>
  import('screens/ResetPasswordV2').then((module) => ({
    default: module.ResetPasswordV2,
  }))
)

function App(): JSX.Element {
  return (
    <RecoilRoot>
      <ThemeProvider>
        <div className="App">
          <ToastContainer />
          <Routes>
            <Route
              path={routes.activateAccount.path}
              element={<ActivateAccount />}
            />
            <Route path={routes.mobileApp.path} element={<MobileApp />} />
            <Route
              path={routes.mobileRegister.path}
              element={<MobileRegister />}
            />
            <Route
              path={routes.confirmEmailUpdate.path}
              element={<ConfirmEmailUpdate />}
            />
            <Route
              path={routes.editCreditCard.path}
              element={<EditCreditCard />}
            />
            <Route
              path={routes.resetPassword.path}
              element={<ResetPassword />}
            />
            <Route
              path={routes.resetPasswordV2.path}
              element={
                <Suspense fallback={null}>
                  <ResetPasswordV2 />
                </Suspense>
              }
            />
            <Route
              path={routes.deleteAccount.path}
              element={<DeleteAccount />}
            />
            <Route path={routes.openChat.path} element={<OpenChat />} />
            <Route path={routes.openReferral.path} element={<OpenReferral />} />
            <Route path={routes.support.path} element={<Support />} />
            <Route
              path={routes.supportCenter.path}
              element={<OpenSupportCenter />}
            />
            <Route path={routes.tellyPhone.path} element={<TellyPhone />} />
            <Route path={routes.getApp.path} element={<GetApp />} />
            <Route
              path={routes.passwordResetCheckEmail.path}
              element={<PasswordResetCheckEmail />}
            />
            <Route
              path={routes.register.path}
              element={
                <Suspense fallback={null}>
                  <Register />
                </Suspense>
              }
            />
          </Routes>
        </div>
      </ThemeProvider>
    </RecoilRoot>
  )
}

export default App
